module.exports = __webpack_public_path__ + "img/mooncake.26beb73e.png";